import styled from 'styled-components';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { CloseButtonInModal } from '../../../common/CloseButtonInModal';
import TransitioningModal from '../../TransitioningModal';
import { desktopMediaQuery } from '../../../../styleHelpers';
import useChatHelpers, {
  useImageRetry,
} from '../../../../hooks/chat/useChatHelpers';

interface ShowChatImagesModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const ShowChatImagesModal = ({ show, setShow }: ShowChatImagesModalProps) => {
  const {
    currentImageUrl,
    botName,
    navigateToImage,
    hasNextImage,
    hasPrevImage,
  } = useChatHelpers();

  const { handleImageLoadError, retryEnabledImageUrl } =
    useImageRetry(currentImageUrl);

  const handleClose = () => setShow(false);

  return (
    <Modal
      isOpen={show}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 100,
        },
        content: {
          position: 'relative',
          padding: '16px',
          backgroundColor: 'rgba(0,0,  0, 0.8)',
          border: 'none',
          width: '90vw',
          maxWidth: '800px',
          height: '90vh',
          margin: 'auto',
          marginTop: '1vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      ariaHideApp={false}
      shouldFocusAfterRender={false}
      onRequestClose={handleClose}
    >
      <CloseButtonInModal onClick={handleClose} />
      <BotNameTitle>{botName}</BotNameTitle>
      <ImageContainer>
        <NavigationButton
          onClick={() => navigateToImage('prev')}
          disabled={!hasPrevImage}
        >
          <FaArrowLeft />
        </NavigationButton>
        <ResponsiveImage
          src={retryEnabledImageUrl}
          alt="Character"
          onError={handleImageLoadError}
        />
        <NavigationButton
          onClick={() => navigateToImage('next')}
          disabled={!hasNextImage}
        >
          <FaArrowRight />
        </NavigationButton>
      </ImageContainer>
    </Modal>
  );
};

const Modal = styled(TransitioningModal)`
  display: flex;
  flex-direction: column;
  z-index: 3;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const ResponsiveImage = styled.img`
  max-height: 85vh;
  max-width: 90%;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;

  ${desktopMediaQuery} {
    max-height: 85vh;
    max-width: 95%;
  }
`;

const BotNameTitle = styled.h2`
  font-size: 24px;
  margin: 2px 0 -8px 0;
  text-align: center;
  color: inherit;

  ${desktopMediaQuery} {
    font-size: 28px;
  }
`;

const NavigationButton = styled.button`
  background: rgba(255, 255, 255, 0.3);
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: 0 4px;
  color: white;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.5);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${desktopMediaQuery} {
    width: 48px;
    height: 48px;
  }
`;

export default ShowChatImagesModal;
